import React from 'react';
import EventForm from './EventForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';

const EventModal = ({ wizardOpen, timezones }) => {
  return (
    <StandardModal
      isOpen={wizardOpen}
    >
      <EventForm timezones={timezones} />
    </StandardModal>
  );
};


export default EventModal;
